export default "__VITE_ASSET__Byg_kvwI__"